import NotificationsPreview from './NotificationsPreview';

export default NotificationsPreview;
